<template>
  <div class="ls-box-filter ls-no-margin-top ls-sm-space">
    <form class="ls-form ls-form-horizontal row">
      <fieldset>
        <div class="col-md-12">
          <label class="ls-label col-lg-2 col-xlg-1 col-md-3 col-xs-12">
            <b class="ls-label-text">{{ $t('customers.attributes.id') }}</b>
            <input id="code" class="input is-expanded" type="text" :maxlength="9" @keyup="filterCustomers('id', $event)" v-model="id" :placeholder="$t('customers.placeholder.id_example')">
          </label>
          <label class="ls-label col-lg-3 col-xlg-2 col-md-3 col-xs-12">
            <b class="ls-label-text">{{ $t('customers.attributes.company_name') }}</b>
            <input id="company_name" class="input is-expanded" type="text" @keyup="filterCustomers('company_name', $event)" v-model="company_name" placeholder='Ex.: Razão Social'>
          </label>
          <label class="ls-label col-lg-3 col-xlg-2 col-md-3 col-xs-12">
            <b class="ls-label-text">{{ $t('customers.attributes.name') }}</b>
            <input class="input is-expanded" type="text" @keyup="filterCustomers('name', $event)" v-model="name" :placeholder="$t('customers.placeholder.name_example')">
          </label>
          <label class="ls-label col-lg-4 col-xlg-3 col-md-3 col-xs-12">
            <b class="ls-label-text">{{ $t('customers.attributes.mail') }}</b>
            <input class="input is-expanded" type="email" @keyup="filterCustomers('email', $event)" v-model="email" :placeholder="$t('customers.placeholder.email_example')">
          </label>
          <label class="ls-label col-lg-2 col-md-3 col-xlg-2 col-xs-12">
            <b class="ls-label-text">{{ $t('customers.filter.document') }}</b>
            <input type="text" class="input is-expanded" @keyup="filterCustomers('document', $event)" v-model="document" :placeholder="$t('customers.placeholder.document_example')">
          </label>
          <label class="ls-label col-lg-2 col-md-3 col-xlg-2 col-xs-12">
            <b class="ls-label-text">{{ $t('customers.attributes.type') }}</b>
            <div class="ls-custom-select">
              <select v-model="kind" class="ls-select" :placeholder="$t('customers.attributes.type')">
                <option value="">{{ $t('application.filter.all') }}</option>
                <option value="P">{{ $t('customers.attributes.personal') }}</option>
                <option value="C">{{ $t('customers.attributes.customer') }}</option>
              </select>
            </div>
          </label>
          <label class="ls-label col-lg-2 col-xlg-2 col-md-3 col-xs-12">
            <b class="ls-label-text">{{ $t('customers.attributes.status') }}</b>
            <div class="ls-custom-select">
              <select v-model="active" class="ls-select" :placeholder="$t('customers.attributes.status')">
                <option value="">{{ $t('application.filter.all') }}</option>
                <option value="true">{{ $t('application.filter.active') }}</option>
                <option value="false">{{ $t('application.filter.inactive') }}</option>
              </select>
            </div>
          </label>
          <div class="btn-action">
            <button type="button" class="ls-btn-danger ls-no-margin-bottom" @click="clearFilters" @keyup.enter="clearFilters">
              <i class="fa fa-eraser" aria-hidden="true"></i>
              <span>{{ $t('application.filter.clear_filters') }}</span>
            </button>
            <button type="button" class="ls-btn ls-no-margin-bottom" v-on:click="searchCustomers">
              <i class="fa fa-search" aria-hidden="true"></i>
              <span>{{ $t('application.filter.filter') }}</span>
            </button>
          </div>
          <div class="ls-clearfix"></div>
        </div>
      </fieldset>
    </form>
    <div class="column is-5">
    </div>
  </div>
</template>
<script>
  import { setFilterCustomer, clearFilterCustomer } from 'src/app/pages/customers/vuex/mutations-types'
  import { setPagination } from 'src/app/components/shareds/pagination/vuex/mutations-types'

  export default {
    data () {
      return {
        id: '',
        name: '',
        document: '',
        email: '',
        company_name: '',
        kind: '',
        active: '',
        SearchString: ''
      }
    },
    mounted () {
      this.$parent.$on('clearFilters', this.clearFilters)
      this.populateData()
      this.$watch('active', function (val) {
        this.filterCustomers('active')
      })
      this.$watch('kind', function (val) {
        this.filterCustomers('kind')
      })
    },
    methods: {
      searchCustomers () {
        this.$store.commit(setPagination, { per_page: 10, current_page: 1 })
        this.$parent.getCustomers()
      },
      filterCustomers (key, e) {
        this.updateFilter(key, this[key])
        if (e && e.key === 'Enter') {
          this.searchCustomers()
        }
      },
      updateFilter (key, value) {
        key = this.findKey(key)
        if (value !== '' && value !== 'NaN') {
          this.$store.commit(setFilterCustomer, { key: key, value: value })
        } else {
          this.$store.commit(clearFilterCustomer, key)
        }
      },
      populateData () {
        this.id = this.$route.query['customer[id]']
        this.name = this.$route.query['customer[name]']
        this.document = this.$route.query['customer[cpf_or_cnpj]']
        this.email = this.$route.query['customer[email]']
        this.company_name = this.$route.query['customer[company_name]']
        this.kind = this.$route.query['customer[kind]']
        this.active = this.$route.query['customer[active]']
      },
      findKey (key) {
        switch (key) {
          case 'id': return 'customer[id]'
          case 'company_name': return 'customer[company_name]'
          case 'name': return 'customer[name]'
          case 'document': return 'customer[cpf_or_cnpj]'
          case 'email': return 'customer[email]'
          case 'kind': return 'customer[kind]'
          case 'active': return 'customer[active]'
        }
      },
      clearFilters () {
        var allAttributes = this.attributes()
        for (var i in allAttributes) {
          this.updateFilter(allAttributes[i], '')
          this[allAttributes[i]] = ''
        }
        this.$parent.getCustomers()
      },
      attributes () {
        return ['id', 'name', 'document', 'email', 'kind', 'active', 'company_name']
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Filter.vue?f0f37300